<template>
  <hm-col cols="5">
    <template v-for="numPersons in intArray(roomType.maxOccupancy - roomType.minOccupancy + 1, roomType.minOccupancy)">
      <hm-input-money :value="calculatedRates[numPersons]"
                      :key="numPersons"
                      :disabled="true"
                      :name="$t('seasonRateEditor.rateEditorCalculatedRates.calculatedRateXPers', { numPersons: numPersons })"
                      label="Zimmerpreis"
                      cols="12"/>
    </template>
  </hm-col>
</template>

<script>
import HmInputMoney from '../inputs/HmInputMoney';

export default {
  name: 'RateEditorCaculatedRates',

  props: {
    roomType: {
      required: true,
      type: Object,
    },
    calculatedRates: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
    };
  },

  methods: {
    intArray: function (value, offset = 0) {
      return [...Array(value).keys()].map(x => x + offset);
    },
  },
};
</script>

<style scoped lang="scss">

</style>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/lib/seasonRateEditor/RateEditorCaculatedRates.vue